import { saveAs } from "file-saver";
import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const AppBer = () => {
    const saveFile = () => {
        saveAs(
            "./Farid_Hossain_Web_Developer_Resume.pdf",
            "Farid-Hossain-Resume.pdf"
        );
    };
    const handleMode = (e) => {
        if (e.target.checked) {
            document.documentElement.setAttribute('data-theme', 'dark');         
        }
        else {
            document.documentElement.setAttribute('data-theme', 'light');
        }
    }
    return (
        <Navbar style={{ height: "100px" }} expand="lg">
            <Container>
                <Link to="/" className='logo'> jibon </Link>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto">
                        <Link className='nav-my btn-buy' to="/"><span>Home</span></Link>
                        {/* <Link className='nav-my btn-buy' to="/about"><span>About</span></Link> */}
                        <Link className='nav-my btn-buy' to="/contact"><span>Contact</span></Link>
                        <Link className='nav-my btn-buy' to="/blog"><span>My Blog</span></Link>
                        <button className=' down-btn' onClick={saveFile} download>RESUME</button>
                        <div className="dm">
                            <input type="checkbox" onChange={(e) => handleMode(e)} className="checkbox" id="checkbox" />
                                <label for="checkbox"  className="label">
                                    <i className="fas fa-moon"></i>
                                    <i className='fas fa-sun'></i>
                                    <div className='ball' />
                                </label>
                        </div>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default AppBer;